export const EVENT_MEDIA_STATUS = {
    SOURCE_GONE: "SOURCE_GONE",
    SOURCE_AVAILABLE: "SOURCE_AVAILABLE",
    CREATE_PREVIEW_VIDEO_REQUEST_SENT: "CREATE_PREVIEW_VIDEO_REQUEST_SENT",
    CREATE_SIGNED_URL_IN_PROGRESS: "CREATE_SIGNED_URL_IN_PROGRESS",
    MEDIA_INITIATED: "MEDIA_INITIATED",
    MEDIA_CREATED: "MEDIA_CREATED",
    MEDIA_UPLOAD_INITIATED: "MEDIA_UPLOAD_INITIATED",
    MEDIA_UPLOAD_COMPLETED: "MEDIA_UPLOAD_COMPLETED",
    PREVIEW_VIDEO_AVAILABLE: "PREVIEW_VIDEO_AVAILABLE",
    ERROR: "ERROR", // DEPRECATED_VIDEO_PREVIEW_REQUEST
    ERROR_REQUEST_TIMEOUT: "ERROR_REQUEST_TIMEOUT",
    ERROR_MQTT_FAILED: "ERROR_MQTT_FAILED",
    ERROR_UPLOAD_FAILED: "ERROR_UPLOAD_FAILED",
    ERROR_SHORT_FAILED: "ERROR_SHORT_FAILED",
    ERROR_RECORDING_FAIL: "ERROR_RECORDING_FAIL",
    ERROR_DOWNLOAD_FAILED: "ERROR_DOWNLOAD_FAILED",
    ERROR_MEDIA_FAILED: "ERROR_MEDIA_FAILED",
    ERROR_PLAYBACK_FAILED: "ERROR_PLAYBACK_FAILED",
    NOT_FOUND_PREVIEW_IMAGE: "NOT_FOUND_PREVIEW_IMAGE",
    SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE: "SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE",
}

export const RC_API_EVENT_MEDIA_STATUS = {
    AVAILABLE: "AVAILABLE",
    CREATE_PREVIEW_VIDEO_REQUEST_SENT: "CREATE_PREVIEW_VIDEO_REQUEST_SENT",
    ERROR: "ERROR",
    ERROR_REQUEST_TIMEOUT: "ERROR_REQUEST_TIMEOUT",
    PENDING: "PENDING",
    PENDING_UPLOAD: "PENDING_UPLOAD",
    PREPARING_ON_DEVICE: "PREPARING_ON_DEVICE",
    SOURCE_AVAILABLE: "SOURCE_AVAILABLE",
    SOURCE_GONE: "SOURCE_GONE",
    UPLOAD_FAILED: "UPLOAD_FAILED",
    UPLOADING: "UPLOADING"
}

export const EVENT_MEDIA_REQUEST_TYPE = {
    NONE: "NONE",
    VIDEO_PREVIEW_REQUEST: "VIDEO_PREVIEW_REQUEST", // DEPRECATED_VIDEO_PREVIEW_REQUEST
    USER_MEDIA_REQUEST: "USER_MEDIA_REQUEST"
}

export const EVENT_MEDIA_TYPE = { // using enumerated types as a pseudo declaration of what types of players are support (i.e, maybe "STREAM" will show up eventually)
    IMAGE: "IMAGE",
    VIDEO: "VIDEO"
}

export const EVENT_MEDIA_CAMERA_TYPE = {
    CAMERA_ROAD: "CAMERA_ROAD",
    CAMERA_CABIN: "CAMERA_CABIN"
}

export const RC_API_EVENT_MEDIA_CAMERA_TYPE = {
    CAMERA_ROAD: "ROAD",
    CAMERA_CABIN: "CABIN"
}
